<template>
    <!-- 被保人填寫資料tab功能 -->
    <div id="insureTab">
        <div class="container">
            <h3 class="blueTitle">被保人資料(旅客名單)</h3>
            <tabs class="insureTab" :options="{ useUrlFragment: false }">
                <tab v-for="(roster, key) in pageStorage.adjustData"
                     :key="key"
                     :name="roster.user"
                     :suffix="roster.closeImg"
                >
                    <insureDetail
                        :mainSameCheck="mainSameCheck"
                        :user="roster.user"
                        :user_id="key"
                        :applicantData="props.applicantData"
                        :insureCheck="props.startCheck"
                        :insureType="roster.type"
                        @globalSameCheck = "globalSameCheck"
                        ref="insureDetailRef"
                    />

                </tab>
            </tabs>
        </div>
    </div>
</template>
<script setup>
import insureDetail from "@/components/detail/insure_detail.vue";
import {onMounted, ref} from "vue";
import $ from 'jquery'


const props = defineProps({
    applicantData: Object,
    startCheck:Boolean
})
const emits = defineEmits(["reloadInsureTab"]);

        const pageStorage = ref(JSON.parse(sessionStorage.getItem("pageStorage")));
        let detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));

        const mainSameCheck = ref();
        const insureDetailRef = ref();

        //增加刪除按鈕
        const createDeleteImg = ()=>{
            pageStorage.value.adjustData.forEach((adjust,index)=>{
                if(index !== 0){
                    adjust.closeImg = "<img data-id='"+index+"' class='closeImg delete-roster' alt='close'/>";
                }else{
                    adjust.closeImg = "";
                }
            });
        }
        const createDetailRoster = () => {
            if (detailStorage == null) {
                detailStorage = {};
                detailStorage.insureData = [];
                pageStorage.value.rosters.forEach(() =>{
                    detailStorage.insureData.push({});
                });
                sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
            }else{
                if(pageStorage.value.rosters.length !== detailStorage.insureData.length){
                    detailStorage = {};
                    detailStorage.insureData = [];
                    pageStorage.value.rosters.forEach(() => {
                        detailStorage.insureData.push({});
                    })
                    sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));
                }
            }
        }
        const deleteInsure = (index) => {
            pageStorage.value = JSON.parse(sessionStorage.getItem("pageStorage"));
            detailStorage = JSON.parse(sessionStorage.getItem("detailStorage"));

            pageStorage.value.adjustData.splice(index, 1);
            pageStorage.value.rosters.splice(index, 1);
            detailStorage.insureData.splice(index, 1);

            sessionStorage.setItem("pageStorage", JSON.stringify(pageStorage.value));
            sessionStorage.setItem("detailStorage", JSON.stringify(detailStorage));

            emits('reloadInsureTab')

        }
        const globalSameCheck = (data)=>{
            mainSameCheck.value = data;
        }
        const checkInsureForm = ()=>{
            insureDetailRef.value.forEach(idRef => {
                idRef?.checkForm();
            })
        }
        const addInsureTraveler = ()=>{
            insureDetailRef.value.forEach(idRef => {
                idRef?.addTraveler();
            })
        }

        createDeleteImg();
        defineExpose({ checkInsureForm,addInsureTraveler }) //父組件需使用

        onMounted(()=>{
            //增加刪除按鈕事件
            $('.closeImg').on('click', function (){
                deleteInsure($(this).data('id'));
            });
            createDetailRoster();
        })


</script>

<style lang="scss">
#insureTab {
    margin: 30px 0 20px;

    .tabs-component ul li a {
        position: relative;
    }

    section{
        padding:0;
    }
    .closeImg {
        content: url("../../assets/close.svg");
        height: 20px;
        width: 20px;
    }

    .delete-roster{
        position: absolute;
        right: 0;
        top:50%;
        transform: translate(-15%, -50%);
        width: 20px;
        opacity: 0.5;
        &:hover{
            opacity: 1;
        }
        @media screen and (max-width: $small) {
            width: 15px;
        }
    }
}
</style>